import React from  'react';
import { withPrefix } from "gatsby";
import { Router } from "@reach/router";
import PrivateRoute from '../../components/Utils/PrivateRoute';
import Kitkat from '../../components/Kitkat/Kitkat';
import Ram from '../../components/Ram/Ram';
import LittleCaesars from '../../components/LittleCaesars/LittleCaesars';
import Pedigree from '../../components/Pedigree/Pedigree';
import Login from '../../components/Login/Login';
import Admin from '../../components/Admin/Admin'

const index = () => {
  return (
    <Router basepath={withPrefix("/partners/")}>
      <PrivateRoute path="ram" component={Ram}/>
      <PrivateRoute path="kitkat" component={Kitkat}/>
      <PrivateRoute path="little-caesars" component={LittleCaesars}/>
      <PrivateRoute path="pedigree" component={Pedigree}/>
      <PrivateRoute path="admin" component={Admin}/>
      <Login path="login" component={Login} default/>
    </Router>
  )
}

export default index
